import { API } from 'utils';
import {
  PaymentArgs,
  PaymentPayload,
  PaymentResponse,
  PaymentStatusPayload,
  PaymentStatusResponse
} from './payment.model';

const pathPart = '/payments';

const effects = () => ({
  registerPayment({ contractId, ...payload }: PaymentArgs) {
    return API.post<PaymentPayload, PaymentResponse>(
      `/contracts/${contractId}${pathPart}`,
      payload
    )
      .then((response) => response)
      .catch((error) => {
        console.error(error);
        return error;
      });
  },
  getPaymentStatus({ orderId }: PaymentStatusPayload) {
    return API.get<void, PaymentStatusResponse>(
      `${pathPart}/status?orderId=${orderId}`,
      true
    )
      .then((response) => response)
      .catch((error) => {
        console.error(error);
        return error;
      });
  }
});

export default effects;
